import { useContext, useEffect, useState } from 'react';
import styles from './dash.module.css';
import { faArrowTrendUp, faBars, faCar, faCarOn, faChartLine, faMotorcycle, faUserNurse } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { groupByDay, groupByMonth, groupByWeek } from '../../utilities/GraphData';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Bar from '../../components/bar/Bar';
import { TotalDriverContext } from '../onlineDrivers/totalOnlineContext';

const med = [{
    id: 1,
    name: "Car",
    icon: faCar,
    description: "totalcar",
    medium: ["Alto", "Swift", "Sedan"].join(", ")
},
{
    id: 2,
    name: "Bike",
    icon: faMotorcycle,
    description: "totalbike",
    medium: ["Scottie"]
},
{
    id: 3,
    name: "Premium",
    icon: faCarOn,
    description: "totalpremium",
    medium: ["KIA", "SUV", "Innova"].join(", ")
}
]
const Dashboard = () => {
    const [data, setData] = useState([]);
    const [val, setVal] = useState("week");
    const [tot, setTotal] = useState(0)
    const [show, setShow] = useState(false);
    const [groupedData, setGroupedData] = useState({
        day: [],
        month: [],
        week: []
    });



    const fetchTotal = async () => {
        try {
            const result = await axios.get(
                `${process.env.REACT_APP_URL}/api/rides/dashboard/total`,
                { withCredentials: true }
            )
            if (result.data.totals) {
                setTotal(result.data.totals)
            }
        } catch (error) {
            console.log("error")
        }

    }
    const fetchData = async () => {
        const year = new Date().getFullYear();
        console.log(year, "date");
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_URL}/api/rides/totals/trips/${year}`,
                { withCredentials: true }
            )
            const reaData = response.data.entireTrips
            if (reaData) {
                console.log("data", reaData);
                setData(groupByWeek(reaData));
                setGroupedData({
                    week: groupByWeek(reaData),
                    month: groupByMonth(reaData),
                    day: groupByDay(reaData)
                });
            }
        } catch (error) {
            console.log(error);
        }
    }




    const { locations } = useContext(TotalDriverContext);


    useEffect(() => {
        fetchTotal();
        fetchData();
    }, [])



    useEffect(() => {
        if (val === "week") {
            setData(groupedData.week);
        } else if (val === "month") {
            setData(groupedData.day);
        } else if (val === "year") {
            setData(groupedData.month);
        }
    }, [val, groupedData]);

    return (
        <div className={styles.mainContainer}>
            <h1 className={styles.header}>Dashboard</h1>
            <div className={styles.container}>
                <div className={styles.item}>
                    <h2>Drivers<FontAwesomeIcon icon={faUserNurse} className={styles.icon} /></h2>
                    <span className={styles.subItems}>
                        <label className={styles.tot}>
                            <FontAwesomeIcon icon={faUserNurse} className={styles.icon} /> Drivers Online
                            <span>{locations.length}</span>

                        </label>

                        <label className={styles.tot}> <FontAwesomeIcon icon={faUserNurse} className={styles.icon} />Total Drivers
                            <span>{tot.driver_total ? tot.driver_total : 0}</span>
                        </label>
                    </span>
                    <p>
                        <label>
                            <span>
                                <FontAwesomeIcon icon={faArrowTrendUp} className={styles.ic} />
                                +{tot.driver_current_month ? tot.driver_current_month : 0}
                            </span>
                            <span>
                                up from last month
                            </span>
                        </label>

                    </p>
                </div>
                <div className={styles.item}>
                    <h2>Performance overview<FontAwesomeIcon icon={faChartLine} className={styles.icon} /></h2>
                    <div className={styles.items}>
                        <div className={styles.p}>
                            <h3>Total Users</h3>
                            <h2>
                                {tot.rider_total ? tot.rider_total : 0}
                            </h2>
                            <p>
                                <label>
                                    <span>
                                        <FontAwesomeIcon icon={faArrowTrendUp} className={styles.ic} />
                                        +{tot.rider_current_month ? tot.rider_current_month : 0}
                                    </span>
                                    <span>
                                        up from last month
                                    </span>
                                </label>
                            </p>
                        </div>
                        <div className={styles.p}>
                            <h3>Total Completed Trips</h3>
                            <h2>
                                {tot.trips_total ? tot.trips_total : 0}
                            </h2>
                            <p>
                                <label>
                                    <span>
                                        <FontAwesomeIcon icon={faArrowTrendUp} className={styles.ic} />
                                        +{tot.trips_current_month ? tot.trips_current_month : 0}
                                    </span>
                                    <span>
                                        up from last month
                                    </span>
                                </label>
                            </p>

                        </div>

                    </div>
                </div>
                <div className={styles.item}>
                    <div className={styles.subItes}>
                        <h2>Ride Medium</h2>
                        <div className={styles.modes}>
                            {
                                med.map((me, index) => (
                                    <div className={styles.mode} key={index}>
                                        <div className={styles.m}>
                                            <h3>{me.name}</h3>
                                            <p> {me.medium}</p>
                                        </div>

                                        <h4>{tot[me.description] ? tot[me.description] : 0}</h4>
                                        <div className={styles.icontainer}>
                                            <FontAwesomeIcon icon={me.icon} />
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <div className={styles.subItes}>
                        <h2>
                            Ride Options
                        </h2>
                        <div className={styles.roptions}>
                            <p>Outstation</p>
                            <p>Intercity</p>

                        </div>
                    </div>
                </div>
                <div className={styles.item} >
                    <div className={styles.head4}>
                        <h2>Trips this {val === 'month' ? new Date().toLocaleString('default', { month: 'long' }) : val} </h2>
                        <div className={styles.click} onClick={() => setShow((prev) => !prev)}>
                            <FontAwesomeIcon icon={faBars} className={styles.fon} />
                            {show && <div className={styles.select}>
                                <button onClick={() => setVal("week")}>Week</button>
                                <button onClick={() => setVal("month")}>Month</button>
                                <button onClick={() => setVal("year")}>Year</button>
                            </div>}
                        </div>
                    </div>
                    <div
                        className={`${styles.containergraph} ${val === "month" ? styles.month : ''}`}>

                        <div
                            className={`${styles.graphcontainer} ${val === "month" ? styles.monthi : ''}`}>
                            <Bar data={data} />
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default Dashboard;
